import { makeStyles } from "@material-ui/core";
import { Box, Typography } from "@mui/material";
import SavingsGraph from "./widgets/SavingsGraph";
import GimmickyIcon from "src/assets/savings_gimmicky.svg";
import BlueBonnetIcon from "src/assets/savings_bluebonnet.svg";
import SavingsIcon from "src/assets/savings_icon.svg";
import PremiseIcon from "src/assets/premiseIcon.svg";
import BedroomIcon from "src/assets/double-bed.svg";
import BathroomIcon from "src/assets/bathtub.svg";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "src/store";
import { graph2, monthTicks } from "src/mock/graph";
import { getPremiseDetails, setViewInStore } from "src/slices/bkvReducer";
import eye from "../icons/eye.svg";
import { useTheme } from "@mui/material/styles";
import { Link } from "@mui/material";
import constants from "src/constants";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Utils } from "src/utils/Utils";
import { useCookies } from "react-cookie";
export default ({ handleOpen, content }) => {
  const state = useSelector((state) => state.bkv);
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:500px)");
  const [cookies] = useCookies();
  const [dim, setDim] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [csavingsPercentage, setCsavingsPercentage] = useState(0);
  const [csavings, setCsavings] = useState(0);

  const [graphData, setGraphData] = useState([]);
  const savingPercentage = 15;
  const lg = dim.width > 960;
  const md = dim.width < 960 && dim.width > 600;
  const sm = dim.width < 600;

  // const [buttonHeight, setButtonHeight] = useState("12rem")
  const ctaRef = useRef();
  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    whiteSpace: "nowrap",
  }));
  useEffect(() => {
    function handleWindowResize() {
      const { innerWidth, innerHeight } = window;
      let winSize = { width: innerWidth, height: innerHeight };
      setDim(winSize);
    }
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
    const costData = [];
    const usageArr = Object.keys(state.usage)
      .map((month) => Number(month))
      .sort((a, b) => a - b)
      .map(
        (month) =>
          state.usage[String(month).padStart(2, "0")] ||
          state.usage[String(month)]
      );
    for (let index = 0; index < 12; index++) {
      const usage = usageArr[index];
      if (!usage) return;
      let temp = 2000;
      [2000, 1000, 500].map((item) => {
        if (usage < temp) {
          temp = item;
        }
      });

      const gim =
        parseInt(Number(state.gimmicky[`kWh${temp}`]).toFixed(0)) / 100;
      const bb =
        parseInt(
          Number(
            state.bluebonnet.Pricing[0][`kWh${temp}`].replace("¢", "")
          ).toFixed(0)
        ) / 100;
      costData.push({
        name: monthTicks[index],
        gimmicky: parseInt((gim * usage).toFixed(0)),
        bluebonnet: parseInt((bb * usage).toFixed(0)),
      });
    }

    const gimmickysum = costData.reduce((accumulator, object) => {
      return accumulator + object.gimmicky;
    }, 0);

    const bluebonnetsum = costData.reduce((accumulator, object) => {
      return accumulator + object.bluebonnet;
    }, 0);

    const cumulativeSavingsPercentage =
      ((gimmickysum - bluebonnetsum) / gimmickysum) * 100;
    setCsavingsPercentage(cumulativeSavingsPercentage);
    setCsavings(gimmickysum - bluebonnetsum);
    setGraphData(costData);
    // console.log("costData", costData);
  }, [state.bluebonnet.rate, state.gimmicky, state.usage]);

  const showUsage = () => {
    handleOpen("usageModal");
    dispatch(setViewInStore("showUsageGraph"));
  };

  const getYourPlanFromUrl = () => {
    const fullPath = window.location.pathname;
    const planComparison = fullPath.split("/").pop();
    const planNames = planComparison.split("-vs-");
    return planNames[1] ? planNames[1].replace(/-/g, " ") : "Your Plan";
  };

  const yourPlan = getYourPlanFromUrl();
  // console.log(state);
  return (
    <>
      <Typography
        sx={{
          fontSize: { xs: "5.5vw", sm: "5.5vw", md: "5vw", lg: "60px" },
          color: theme.palette.primary.main,
          whiteSpace: "wrap",
          marginTop: { xs: "10%", sm: "10%", md: "6%", lg: "4%" },
          marginBottom: { xs: "10%", sm: "10%", md: "6%", lg: "2%" },
        }}
        align="center"
        variant="body2"
        padding={{ xs: "0 10%", sm: "0 10%", md: "0 10%", lg: "0 5%" }}
      >
        {!isNaN(csavings) && csavings <= 0
          ? "You're one of the few Texans with the right energy usage who may save money by sticking with the Polyedra plan"
          : `Last year you would have saved $${
              isNaN(csavings) ? 0 : csavings
            } with Bluebonnet`}
      </Typography>
      <Box className={classes.root}>
        <Box id="savings-graph" className={classes.graphContainer}>
          <Box className={classes.legend}>
            <Box className="container">
              <img src={GimmickyIcon} alt="gimmicky-icon" />
              <Typography>{yourPlan}</Typography>
            </Box>
            <Box className="container">
              <img src={BlueBonnetIcon} alt="bluebonnet-icon" />
              <Typography>Bluebonnet plan</Typography>
            </Box>
            {!sm && (
              <Box className="container">
                <img src={SavingsIcon} alt="savings-icon" />
                <Typography>Cumulative Savings</Typography>
              </Box>
            )}
          </Box>

          <SavingsGraph data={graphData} dataKey={"name"} />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "column",
              },
            }}
            className={classes.belowGraph}
          >
            <Box
              // className={classes.premise}
              sx={{
                borderRadius: { xs: "5vw", sm: "5vw", md: "5vw", lg: "20px" },
                boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
                position: "relative",
                padding: { xs: "10%", sm: "10%", md: "10%", lg: "40px" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: {
                  xs: "1.5% 1.5% 3% 1.5%",
                  sm: "1.5% 1.5% 3% 1.5%",
                  md: "1.5% 1.5% 3% 1.5%",
                  lg: "10px",
                  flexDirection: { xs: "column", lg: "row" },
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",

                  // justifyContent: "center",

                  margin: { xs: "1.5%", lg: "10px" },
                  width: { sm: "92%", xs: "90%", lg: "90%" },
                  // height: { xs: "auto", lg: "10vw" },
                },

                width: { xs: "80%", sm: "92%", md: "80%", lg: "90%" },
                height: { xs: "auto", sm: "auto", md: "auto", lg: "10vw" },
              }}
            >
              <Box
                className="inner"
                sx={{
                  padding: { xs: "0", lg: "4%" },
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  justifyContent: "space-around",
                  alignItems: "center",
                  gap: { xs: "5%", lg: "14%" },
                  marginTop: { xs: "2%", lg: "0" },
                  width: { xs: "92%", sm: "100%", md: "92%", lg: "100%" },
                }}
              >
                {!isMobile && (
                  <Box className={classes.flexBox}>
                    <img src={PremiseIcon} width="35vw" alt="bathroom" />
                  </Box>
                )}
                <Box
                  flex="2"
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-around"
                >
                  <Box
                    className="details"
                    sx={{ textAlign: { xs: "center", lg: "center" } }}
                  >
                    <Typography
                      variant="h3"
                      className="street"
                      fontSize={{ xs: "4vw", sm: "4vw", md: "2vw", lg: "20px" }}
                    >
                      {state.address?.label}
                    </Typography>

                    {/* {state.premise?.bedrooms && ( */}
                    <Box
                      className={classes.flexBox}
                      padding={{ xs: "5px 0 5px 0" }}
                      justifyContent="center"
                    >
                      {state.premise?.lot_size && (
                        <Box
                          margin="0 0 0 20px"
                          display="flex"
                          flexDirection="row"
                        >
                          <Typography
                            // padding="10%"
                            fontSize={{
                              xs: "4vw",
                              sm: "4vw",
                              md: "4vw",
                              lg: "15px",
                            }}
                          >
                            {state.premise?.lot_size} SqFt.
                          </Typography>
                        </Box>
                      )}
                      {state.premise?.bedrooms && (
                        <Box
                          margin="0 0 0 20px"
                          display="flex"
                          flexDirection="row"
                        >
                          <img
                            src={BedroomIcon}
                            width="20vw"
                            alt="bedroom"
                            style={{ padding: "0 2px" }}
                          />
                          <Typography
                            fontSize={{
                              xs: "4vw",
                              sm: "4vw",
                              md: "4vw",
                              lg: "15px",
                            }}
                          >
                            {state.premise?.bedrooms}
                          </Typography>
                        </Box>
                      )}

                      {state.premise?.bathrooms && (
                        <Box
                          margin="0 0 0 20px"
                          display="flex"
                          flexDirection="row"
                        >
                          <img
                            src={BathroomIcon}
                            width="15vw"
                            style={{ padding: "0 2px" }}
                            alt="bathroom"
                          />
                          <Typography
                            fontSize={{
                              xs: "4vw",
                              sm: "4vw",
                              md: "4vw",
                              lg: "15px",
                            }}
                          >
                            {state.premise?.bathrooms}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    {/* )} */}

                    {/* {!isMobile && (
                      <Box className={classes.flexBox}>
                        <img src={PremiseIcon} width="35vw" alt="bathroom" />
                        {state.premise?.bathrooms && (
                          <Typography
                            fontSize={{
                              xs: "4vw",
                              sm: "4vw",
                              md: "2vw",
                              lg: "25px",
                            }}
                          >
                            {state.premise?.bathrooms}
                          </Typography>
                        )}
                      </Box>
                    )} */}
                    {/* Render bathrooms outside of the conditional rendering to ensure it shows on mobile */}
                    {/* {isMobile && state.premise?.bathrooms && (
                      <Box className={classes.flexBox}>
                        <img src={BathroomIcon} width="20vw" alt="bathroom" />
                        <Typography
                          fontSize={{
                            xs: "4vw",
                            sm: "4vw",
                            md: "2vw",
                            lg: "25px",
                          }}
                        >
                          {state.premise?.bathrooms}
                        </Typography>
                      </Box>
                    )} */}
                  </Box>
                </Box>

                <Button
                  onClick={showUsage}
                  sx={{
                    padding: "8px 80px",
                    border: "2px #009A88 solid",
                    borderRadius: "20px",
                    marginLeft: { xs: 0, lg: "0px" },
                    width: { xs: "80%", sm: "90%", lg: "40%" },
                    marginTop: "2%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: "2", // Ensures content is centered
                  }}
                >
                  <img
                    src={eye}
                    width="24px"
                    alt="eye"
                    style={{ marginRight: "10px" }}
                  />
                  <Typography
                    sx={{
                      color: "#009A88",
                      fontSize: {
                        xs: "4vw",
                        sm: "3.5vw",
                        md: "3vw",
                        lg: "25px",
                      },
                      fontWeight: "bold",
                      textTransform: "none",
                    }}
                  >
                    ANNUAL USAGE
                  </Typography>
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                background:
                  "linear-gradient(94deg, #FFD27D -4.14%, #00B49D 36.64%, #09507F 79.16%)",
                borderRadius: { xs: "5vw", sm: "5vw", md: "5vw", lg: "20px" },
                boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
                flexDirection: { xs: "column", lg: "row" },
                justifyContent: "center",
                position: "relative",
                padding: { xs: "10%", sm: "10%", md: "10%", lg: "40px" },
                display: "flex",
                alignItems: "center",
                // margin: {
                //   xs: "1.5% 1.5% 3% 1.5%",
                //   sm: "1.5% 1.5% 3% 1.5%",
                //   md: "1.5% 1.5% 3% 1.5%",
                //   lg: "10px",
                // },
                width: { xs: "80%", sm: "92%", md: "80%", lg: "90%" },
                height: { xs: "auto", sm: "auto", md: "auto", lg: "10vw" },
              }}
            >
              <Box
                className="inner"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 2,
                }}
              >
                <Box sx={{ textAlign: "center" }} flex="2">
                  {csavingsPercentage < 0 ? (
                    <Typography
                      fontSize={{ xs: "4vw", sm: "4vw", md: "2vw", lg: "24px" }}
                      color="#fff"
                      fontWeight="bold"
                    >
                      <b>
                        Your bills may be a bit lower with Polyedra, but the
                        Bluebonnet plan comes with huge benefits!
                      </b>
                      <br />
                      <Typography
                        marginBottom="0%"
                        fontSize={{
                          xs: "4vw",
                          sm: "4vw",
                          md: "2vw",
                          lg: "18px",
                        }}
                      >
                        Such as an annual payout, customer loyalty program, and
                        gift card giveaways.
                      </Typography>
                      <br />
                    </Typography>
                  ) : (
                    <Typography
                      fontSize={{ xs: "4vw", sm: "4vw", md: "2vw", lg: "20px" }}
                      color="#fff"
                    >
                      With the <strong>Bluebonnet</strong> plan you would have{" "}
                      <b>
                        saved{" "}
                        {isNaN(csavingsPercentage)
                          ? 0
                          : csavingsPercentage.toFixed(2)}
                        %
                      </b>{" "}
                      on energy bills last year
                    </Typography>
                  )}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginTop: "2%",
                    width: "100%",
                  }}
                  flex="2"
                >
                  <Link
                    underline="none"
                    href={Utils.getEnrollmentLink(
                      state.zipcode,
                      "SEOEIQ0001",
                      state.bluebonnet.ProductId,
                      state.bluebonnet.Pricing?.[0]?.Terms,
                      state.address.esiid
                    )}
                    color="inherit"
                    width="100%"
                    sx={{ display: "flex", justifyContent: "center" }}
                    target="_blank"
                  >
                    <Button
                      className={classes.button2}
                      sx={{
                        padding: "12px 10px",
                        width: "100%",
                        maxWidth: "400px",
                        backgroundColor: theme.palette.mustard.main,
                      }}
                    >
                      <Typography
                        fontSize={{
                          xs: "3vw",
                          sm: "3vw",
                          md: "3vw",
                          lg: "15px",
                        }}
                        sx={{ lineHeight: "21px", fontWeight: "1000" }}
                      >
                        <b>SIGN UP FOR BLUEBONNET</b>
                      </Typography>
                    </Button>
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    padding: "1% 3% 1% 3%",
    [theme.breakpoints.down("md")]: {
      padding: "1% 5% 1% 5%",
    },
  },
  title: {
    fontFamily: "Larken DEMO medium",
    color: "#09507F",
    textAlign: "center",
  },
  graphContainer: {
    marginTop: 30,
    borderRadius: 40,
    border: "1px solid #99D7CF",
    padding: "20px 15px 20px 15px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      borderRadius: 16,
      marginTop: 0,
    },
  },
  legend: {
    margin: "10px auto 3% 2%",
    display: "flex",
    gap: 60,
    "& .container": {
      display: "flex",
      gap: 8,
      alignItems: "center",
    },
    [theme.breakpoints.down("sm")]: {
      gap: 30,
      "& img": {
        width: 30,
        height: 5,
        objectFit: "cover",
      },
      "& p": {
        fontSize: 10,
      },
    },
  },
  belowGraph: {
    boxSizing: "border-box",
    marginTop: 40,
    gap: 30,
    padding: "10px 10px",
    [theme.breakpoints.down("sm")]: {
      marginTop: 20,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 20,
      padding: 0,
    },
  },
  premise: {
    boxSizing: "border-box",
    flex: 0.5,
    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
    padding: "30px 20px",
    display: "flex",
    borderRadius: 15,
    alignItems: "start",
    height: "12rem",
  },
  cta: {
    height: "12rem",
    boxSizing: "border-box",
    flex: 0.5,
    borderRadius: 15,
    color: "#fff",

    background:
      "linear-gradient(94deg, #FFD27D -4.14%, #00B49D 36.64%, #09507F 79.16%)",
    textAlign: "center",
    padding: 20,
    display: "flex",
    justifyContent: "center",
    "& .inner": {
      width: "100%",
    },
    [theme.breakpoints.down("lg")]: {
      height: "20%",
    },
  },
  premiseDetails: {
    alignSelf: "center",
    display: "flex",
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    "& .street": {
      fontWeight: "bold",
    },
    "& .details": {
      marginTop: 10,
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      gap: 14,
      "& p": {
        color: "#2F2F2F",
      },
      "& img": {
        marginRight: 5,
      },
    },
  },
  changePlan: {
    marginTop: 10,
    width: "70%",
    padding: "12px, 24px, 12px, 24px",
    color: "#09507F",
    lineHeight: "27px",
    borderRadius: 360,
    fontWeight: "bold",
    backgroundColor: "#EAEAEA",
    "&:hover": {
      backgroundColor: "#fcdeab",
    },
  },
  changePlan2: {
    marginTop: 10,
    width: "70%",
    padding: "12px, 24px, 12px, 24px",
    color: "#09507F",
    lineHeight: "27px",
    borderRadius: 360,
    fontWeight: "bold",
    backgroundColor: "#FFD27D",
    whiteSpace: "nowrap",
    marginLeft: "3%",
    "&:hover": {
      backgroundColor: "#fcdeab",
    },
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
  },
  button1: {
    transition: "all .1s ease-in-out",
    border: "3px solid #fff",
    "&:hover": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "transparent",
    },
  },
  button2: {
    transition: "all .1s ease-in-out",
    border: "3px solid #FFD27D",
    "&:hover": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "transparent",
    },
  },
  "@keyframes scale": {
    "0%": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));
